var swiper = new Swiper(".block_shop-categorie-slider", {
    slidesPerView: 7,
    spaceBetween: 10,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    mousewheel: {
        forceToAxis: true,
      },
    navigation: {
        nextEl: ".block_shop-categories .block_slider-right-arrow",
        prevEl: ".block_shop-categories .block_slider-left-arrow",
    },
    breakpoints: {
        320: {
            slidesPerView: 3.5,
        },
        400: {
            slidesPerView: 4.5,
        },
        480: {
            slidesPerView: 4.5,
        },
        749: {
            slidesPerView: 5,
        },
        989: {
            slidesPerView: 6,
        },
        1280: {
            slidesPerView: 7,
        },
        1499: {
            slidesPerView: 7,
        },
    },
});